@let executionData = execution();

<div class="flex flex-col gap-6 pl-6 pr-2 mt-6">
  <h2 class="text-xl font-bold">{{ analyticsNode().nonExecutedCtaName }}</h2>

  <div class="flex flex-col gap-2">
    <span class="text-[10px] text-shikenso-purple-base-60">
      {{ 'pages.campaignDetails.ctaAnalytics.table.planned' | translate }}
    </span>

    <div class="flex gap-1 items-center text-sm">
      <app-icon src="/icons/calendar-event.svg" alt="Planned Start Date" class="w-4 h-4 shrink-0" />
      @if (plannedExecutionType() === EExecutionType.always) {
        <span>{{ 'pages.campaignDetails.ctaAnalytics.details.deliverables.always' | translate }}</span>
      } @else if (plannedExecutionType() === EExecutionType.undesignated) {
        <span>{{ 'pages.campaignDetails.ctaAnalytics.details.deliverables.anyTimeDuringCampaign' | translate }}</span>
      } @else if (executionData.details.plannedStartDate) {
        <span>{{ executionData.details.plannedStartDate }}</span>
        @if (!analyticsNode().isDateOnlyExecution && executionData.details.plannedStartTime) {
          <span>|</span>
          <span>{{ executionData.details.plannedStartTime }}</span>
        }
      }
    </div>
  </div>

  <div class="flex flex-col gap-3 mr-1">
    <div class="flex items-center justify-between">
      <h3 class="text-base">
        {{ 'shared.tile.deliverables' | translate }}
      </h3>

      <button mat-flat-button type="button" color="secondary-gray" class="mat-micro-button" (click)="toggleExpand()">
        <span class="text-xs">
          @if (isAllExpanded()) {
            {{ 'components.groupedDatatable.collapseAll' | translate }}
          } @else {
            {{ 'components.groupedDatatable.expandAll' | translate }}
          }
        </span>
      </button>
    </div>

    <app-deliverable-list
      [formArray]="plannedDeliverableFormArray()"
      [isViewMode]="true"
      [isAnalyticsPlannedMode]="true"
      [isAllExpanded]="isAllExpanded()"
      [creatorBriefingMode]="creatorBriefingMode()"
    />
  </div>

  <div class="flex flex-col gap-3 mt-3">
    <app-cta-analytics-details-kpi-goals-table
      [execution]="executionData"
      [kpiGoalsKpiCards]="kpiGoalsKpiCards()"
      [isAnalyticsPlannedMode]="true"
    />
  </div>
</div>
